import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { CardsTableProps } from 'components/CardsTable/types';
import './CardsTableColumnsHead.css';
import CardsTableHeadArrowUp from './svgs/CardsTableHeadArrowUp';
import CardsTableHeadArrowDown from './svgs/CardsTableHeadArrowDown';

export const CardsTableColumnsHead = ({
  cellsData,
  orderBy,
  order,
  rowDividerType = 'color-mix',
  onHeaderSortPress,
}: CardsTableProps) => {
  const isColorMix = rowDividerType === 'color-mix';
  const onSortLabelPress = (key: string) => {
    if (onHeaderSortPress) onHeaderSortPress(key);
  };
  return (
    <TableRow>
      {cellsData.headCells.map((headCell) => {
        const isArrowUpSelected = headCell.key === orderBy && order === 'desc';
        const isArrowDownSelected = headCell.key === orderBy && order === 'asc';
        const sortComponent = headCell.noSort
          ? undefined
          : () => (
              <div className="collection-card-sort-icons-container">
                <CardsTableHeadArrowUp isSelected={isArrowUpSelected} />
                <CardsTableHeadArrowDown isSelected={isArrowDownSelected} />
              </div>
            );
        return (
          <TableCell
            key={headCell.label}
            sortDirection={orderBy === headCell.label ? order : false}
            align="left"
            sx={(theme) => ({
              border: !isColorMix ? '1px' : 0,
              backgroundColor: theme.colors.black,
              width: headCell.columnWidth,
            })}
          >
            <TableSortLabel
              active
              sx={(theme) => ({
                color: theme.colors.white,
                fontWeight: 'bold',
                fontSize: 11,
                ':active': { color: theme.colors.white },
                ':hover': { color: theme.colors.white },
                '&.Mui-active': {
                  color: { color: theme.colors.white }, // color when sorted
                },
              })}
              IconComponent={sortComponent}
              onClick={() => onSortLabelPress(headCell.key)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        );
      })}
    </TableRow>
  );
};
